import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { currentUserQueryOptions } from "$/modules/auth/lib/queries";

export const Route = createFileRoute("/$locale/$userId")({
	component: ProtectLayout,
	beforeLoad: async ({ params, context }) => {
		const user = await context.queryClient.fetchQuery(
			currentUserQueryOptions(),
		);

		if (!user) {
			throw redirect({ to: "/$locale", params });
		}

		if (user.$id !== params.userId) {
			throw redirect({
				to: "/$locale/$userId/projects",
				params: { locale: params.locale, userId: user.$id },
			});
		}
		return { user };
	},
});

function ProtectLayout() {
	const { data: user } = useSuspenseQuery(currentUserQueryOptions());
	const { locale, userId } = Route.useParams();
	if (!user) throw redirect({ to: "/$locale", params: { locale } });
	if (user.$id !== userId) {
		throw redirect({
			to: "/$locale/$userId/projects",
			params: { locale, userId: user.$id },
		});
	}
	return <Outlet />;
}
